module.exports = __webpack_public_path__ + "static/media/UAT.69dae8e8.png";